import { Injectable } from '@angular/core';
import { of, throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpProviderService } from 'src/app/core/services';
import {
  HttpRequestPayload,
  IHttpSuccessPayload,
  IHttpErrorPayload,
} from '@core/models';

@Injectable()
export class NoOfLeavesService {
  constructor(private httpProvider: HttpProviderService) {}

  fetchChequeLeaves(): Observable<any[]> {
    const request: HttpRequestPayload = {
      resource: `/lov`,
      queryParams: [
        {
          key: 'lovId',
          value: 'CB_LEAVES',
        },
        {
          key: 'lookup',
          value: '1',
        },
      ],
      method: 'GET',
    };

    return this.httpProvider.invokeApi(request).pipe(
      map((response: IHttpSuccessPayload<any>) => {
        return response.body.Data;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }
}
